// Function to extract primary zip code to avoid Nuvei 400 reject on zipcodes like "80211-1968"
export const getPrimaryZipCode = (zipcode: string): string => {
  return zipcode.includes('-') ? zipcode.split('-')[0] : zipcode;
};
